import { CognitoUserPool } from 'amazon-cognito-identity-js';

import { getUser, getSession } from '..';

interface Input {
    clientId: string;
    userPoolId: string;
}

interface Result {
    token: Maybe<string>;
    error?: Error;
}

/**
 * This function is intended to be used by low-level logic to authenticate API requests.
 * It's not a resolver and doesn't do any cache updates; see src/auth/validateCognitoUserSession for
 * a resolver that updates the cache.
 */
export const getCognitoToken = async ({
    clientId,
    userPoolId,
}: Input): Promise<Result> => {
    const userPool = new CognitoUserPool({
        UserPoolId: userPoolId,
        ClientId: clientId,
    });

    try {
        const user = await getUser(userPool);

        if (user === null) {
            return {
                token: null,
            };
        }

        const session = await getSession(user);
        const token = session?.token ?? null;

        return {
            token,
        };
    } catch (err) {
        return { error: err as Error, token: null };
    }
};
